const SKIP_TRAIN_START = "SKIP_TRAIN_START";
const SKIP_TRAIN_SUCC = "SKIP_TRAIN_SUCC";
const SKIP_TRAIN_FAIL = "SKIP_TRAIN_FAIL";

const initialState = {
    data: {},
    isfetching: false,
    fail: false,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SKIP_TRAIN_START: {
            return {
                ...state,
                isfetching: true,
            }
        }
        case SKIP_TRAIN_SUCC: {
            return {
                ...state,
                isfetching: false,
                data: action.data,
            }
        }
        case SKIP_TRAIN_FAIL: {
            return {
                ...state,
                error: action.error,
                isfetching: false,
                fail: true,
            }
        }
        default: return state
    }
}
